import {FC} from 'react';
import {Controller, useFormContext} from 'react-hook-form';

import {fullRightCreate} from '../helpers';
import {Action, GranularRight} from '../types';
import {CustomCheckbox} from './checkbox';
import {useRights} from './RightsContext';
import {uiDrivenActionStyle} from './styles.module.css';
import TreeBranch from './TreeBranch';

const UIDrivenAction: FC<Pick<Action, 'disabled' | 'label' | 'name'>> = ({
    disabled,
    label,
    name,
}) => {
    const methods = useFormContext();
    const {hasRight} = useRights();
    const isCheckboxDisabled = disabled || !hasRight(name);

    return (
        <Controller
            control={methods.control}
            name={name}
            render={({field: {onBlur, onChange, ref, value}}) => (
                <div className="flex" role="complementary">
                    <CustomCheckbox
                        checked={value}
                        className={uiDrivenActionStyle}
                        disabled={isCheckboxDisabled}
                        label={label}
                        name={name}
                        onBlur={onBlur}
                        onChange={onChange}
                        ref={ref}
                        value={value}
                    />
                </div>
            )}
        />
    );
};

const UIDrivenGranularRight: FC<GranularRight> = ({actions, name}) => {
    const [mainAction, ...nestedActions] = actions;

    if (!mainAction) {
        return null;
    }

    return (
        <div className="my-4" id={`rights.${name}`}>
            <UIDrivenAction
                disabled={mainAction.disabled}
                label={mainAction.label}
                name={fullRightCreate('rights', name, mainAction.name)}
            />
            {nestedActions.length > 0 &&
                nestedActions.map((action, index) => (
                    <div className="flex" key={action.name}>
                        <span className="text-grey-400">
                            <TreeBranch
                                kind={
                                    nestedActions.length - 1 === index
                                        ? 'end'
                                        : 'junction'
                                }
                            />
                        </span>
                        <UIDrivenAction
                            disabled={action.disabled}
                            label={action.label}
                            name={fullRightCreate('rights', name, action.name)}
                        />
                    </div>
                ))}
        </div>
    );
};
export default UIDrivenGranularRight;
